import { useState } from "react";
import { Copy, RefreshCw, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { copyText } from "@/lib/content";

export default function CardSection({ id, title, text, onRegenerate, children }) {
  const [busy, setBusy] = useState(false);
  const regen = async () => {
    setBusy(true);
    try { await onRegenerate(id); } finally { setBusy(false); }
  };
  return (
    <section className="panel p-5 md:p-6 fade-up" data-testid={`card-section-${id}`}>
      <div className="flex flex-wrap items-center justify-between gap-2 mb-4">
        <h2 className="text-base md:text-lg font-display whitespace-nowrap">{title}</h2>
        <div className="flex items-center gap-1">
          {onRegenerate && (
            <button className="text-[11px] uppercase tracking-[0.12em] muted hover:text-[#9C4DDC] px-2 py-1.5 flex items-center gap-1.5 disabled:opacity-50"
              onClick={regen} disabled={busy} data-testid={`card-section-${id}-regenerate-button`}>
              {busy ? <Loader2 size={12} className="animate-spin" /> : <RefreshCw size={12} />} Regenerate
            </button>
          )}
          <button className="text-[11px] uppercase tracking-[0.12em] text-[#9C4DDC] border border-[#9C4DDC]/50 rounded-full px-3 py-1.5 flex items-center gap-1.5 hover:bg-[#9C4DDC]/10"
            onClick={async () => { await copyText(text); toast.success("Copied ✓"); }} data-testid={`card-section-${id}-copy-button`}>
            <Copy size={12} /> Copy
          </button>
        </div>
      </div>
      <div className={busy ? "opacity-40 transition-opacity" : "transition-opacity"}>{children}</div>
    </section>
  );
}
